// The design file's class constants. Compose them; do not restate them.

export const CARD =
  'anim-up w-full rounded-card bg-white px-6 py-8 shadow-card sm:px-10'

export const TITLE = 'font-display text-26 font-bold tracking-heading text-ink'

export const SUBTITLE = 'mt-1.5 mb-5 text-sm text-ink-500'

export const INPUT =
  'w-full rounded-2xl border-1.5 bg-white px-4 py-2.5 font-body text-sm text-ink outline-none transition placeholder:text-line-400 hover:border-line-400 focus:border-brand focus:shadow-focus disabled:cursor-not-allowed disabled:bg-line-200 disabled:text-ink-500'

export function inputCls(error?: boolean, icon?: boolean): string {
  return `${INPUT} ${error ? 'border-danger' : 'border-line-300'}${
    icon ? ' pl-10' : ''
  }`
}

export const LABEL = 'mb-1.5 block text-13 font-medium text-ink-700'

export const FIELD_ERROR = 'mt-1.5 text-xs text-danger'

export const BTN_PRIMARY =
  'inline-flex items-center justify-center gap-1.5 rounded-btn bg-brand px-7 py-3.5 font-display text-15 font-bold text-ink transition hover:bg-brand-600 hover:shadow-glow disabled:cursor-not-allowed disabled:bg-line-200 disabled:text-line-400 disabled:shadow-none'

export const BTN_OUTLINE =
  'inline-flex items-center justify-center rounded-btn border-1.5 border-ink bg-white px-7 py-3.5 font-display text-15 font-semibold text-ink transition hover:bg-line-100'

export const BTN_BACK =
  'flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-1.5 border-line-300 bg-white text-ink-700 transition hover:border-line-400'

export const LINK_BTN =
  'text-13 font-medium text-link no-underline hover:underline'

export const CTA_FILL =
  'w-full rounded-btn bg-brand px-7 py-3.5 font-display text-15 font-bold text-ink transition hover:bg-brand-600 hover:shadow-glow'

export const CTA_OUTLINE =
  'w-full rounded-btn border-1.5 border-ink bg-white px-7 py-3.5 font-display text-15 font-semibold text-ink transition hover:bg-line-100'

export const BTN_SSO =
  'flex w-full items-center justify-center gap-2.5 rounded-btn border-1.5 border-line-300 bg-white px-4 py-3 font-display text-sm font-semibold text-ink-700 transition hover:bg-line-100'

const ROLE_BASE =
  'flex items-start gap-3.5 rounded-2xl border-1.5 p-5 text-left transition'
export const ROLE_ON = `${ROLE_BASE} border-brand bg-brand-100 shadow-card`
export const ROLE_OFF = `${ROLE_BASE} border-line-200 bg-white hover:border-brand hover:bg-brand-50`

const RADIO_BASE =
  'flex w-full items-center gap-3 rounded-2xl border-1.5 px-4 py-3 text-left transition'
export const RADIO_ON = `${RADIO_BASE} border-brand bg-brand-100`
export const RADIO_OFF = `${RADIO_BASE} border-line-300 bg-white hover:border-line-400`

export const STEP_BTN =
  'flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-1.5 border-line-200 bg-white font-display font-bold text-ink transition hover:border-brand disabled:cursor-not-allowed disabled:border-line-200 disabled:bg-line-200 disabled:text-line-300'

export const PLAN_BASE =
  'relative flex flex-col rounded-2xl bg-white p-6 transition'
export const PLAN_FEATURED = `${PLAN_BASE} border-1.5 border-brand shadow-card`
export const PLAN_PLAIN = `${PLAN_BASE} border-1.5 border-line-200 hover:border-line-300 hover:shadow-card`

export const PILL_ON =
  'rounded-pill border-1.5 border-brand bg-brand px-3.5 py-1.5 font-display text-13 font-semibold text-ink transition'
export const PILL_OFF =
  'rounded-pill border-1.5 border-line-300 bg-white px-3.5 py-1.5 font-display text-13 font-medium text-ink-700 transition hover:border-line-400'

export const PAGE =
  'flex min-h-[calc(100vh-56px)] flex-col items-center px-5 py-8'

export const DIVIDER =
  "my-5 flex items-center gap-3.5 text-xs text-ink-500 before:h-px before:flex-1 before:bg-line-200 before:content-[''] after:h-px after:flex-1 after:bg-line-200 after:content-['']"
